import React, { useMemo } from "react";
import { HistoryContext } from "./HistoryContext.jsx";
import { useHistory } from "./useHistory.jsx";

const HistoryProvider = ({ initialState, children }) => {
  const history = useHistory(initialState);
  const value = useMemo(
    () => history,
    [history.state, history.past, history.future]
  );
  return (
    <HistoryContext.Provider value={value}>{children}</HistoryContext.Provider>
  );
};

export default HistoryProvider;
